import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { CommonModule, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatError, MatInput } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MaskIdNumberDirective } from '../../directives/mask-id-number.directive';
import { TextComponent } from '../../shared/components/text/text.component';
import { TagComponent } from '../../shared/components/tag/tag.component';
import { idNoValidator } from '../../shared/utils/validator.util';
import { CheckinService } from '../../shared/services/checkin.service';
import { Router } from '@angular/router';
import { QuestionnaireStatusList } from '../../shared/interfaces/my-reservation.model';
@Component({
    selector: 'app-checkin',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatInput,
        MatError,
        MatSelectModule,
        MatButtonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressBarModule,
        TextComponent,
        TagComponent,
        TranslatePipe,
        NgClass,
        MaskIdNumberDirective,
    ],
    templateUrl: './checkin.component.html',
    styleUrls: ['./checkin.component.scss']
})
export class CheckinComponent {
    toastr: ToastrService = inject(ToastrService);
    translateService: TranslateService = inject(TranslateService);
    checkinService: CheckinService = inject(CheckinService);
    sharedStorageService: SharedStorageService = inject(SharedStorageService);
    router: Router = inject(Router);
    personalData: { name?: string; gender?: string; id?: string } = {
        name: '',
        gender: '',
        id: '',
    };
    idNoMaxLength: number = 10;
    isFormSubmit: boolean = false;
    isIdNumberVisible: boolean = false; // 是否顯示身分證號碼
    checkInStep: number = 1; // 報到流程步驟
    sortedQuestionnaireStatusList: QuestionnaireStatusList[] = []; // 排序後的問卷狀態清單
    diffDays: number = 0; // 預約日期與目前日期相差天數

    step1Form = new FormGroup({
        idNo: new FormControl<string>('', [
            Validators.required,
            (control: FormControl) => idNoValidator(control, this.translateService),
        ]),
    });

    getIdNoErrorMessage(): string {
        const control = this.step1Form.get('idNo');
        if (!control || !control.errors || !this.isFormSubmit) return '';

        const errors = control.errors;
        const noSpecialKeys = ['onlyWhitespace', 'whitespace', 'specialChar'];

        if (errors['required'] || noSpecialKeys.some(key => errors[key])) {
            return this.translateService.instant('error.id-number-error.required');
        }
        if (errors['invalidCharacters']) {
            return errors['invalidCharacters'];
        }

        return '';
    }

    // 切換身分證字號可見性
    toggleIdNumberVisibility() {
        this.isIdNumberVisible = !this.isIdNumberVisible;
    }

    /** 已完成問卷數量（status !== '1'） */
    completedCount(): number {
        return this.sortedQuestionnaireStatusList.filter(item => item.status !== '1' && item.status !== '4').length;
    }

    /** 問卷完成百分比（用於進度條） */
    percentValue(): number {
        const total = this.sortedQuestionnaireStatusList.length;
        if (total === 0) return 0;
        return Math.round((this.completedCount() / total) * 100);
    }

    /** 問卷狀態清單排序（questionnaireTypeId=3 優先，其餘依代號升序） */
    private sortQuestionnaireStatusList(list: QuestionnaireStatusList[]): void {
        this.sortedQuestionnaireStatusList = [...list].sort((a, b) => {
            const idA = Number(a.questionnaireTypeId);
            const idB = Number(b.questionnaireTypeId);
            if (idA === 3 && idB !== 3) return -1;
            if (idB === 3 && idA !== 3) return 1;
            return idA - idB;
        });
    }

    onSubmit() {
        this.isFormSubmit = true;
        if (this.step1Form.valid) {
            const idNo = this.step1Form.get('idNo')?.value || '';

            // 打CB-011
            this.checkinService.getQuestionnaireStatus(idNo).subscribe({
                next: (response) => {
                    console.log('Questionnaire Status:', response);
                    const list = response.data?.questionnaireStatusList ?? [];
                    if (list.length === 0 || response.statusCode !== 'S0000') {
                        this.toastr.error('查無相關紀錄，請確認或詢問現場人員。', '', { positionClass: 'toast-bottom-center' });
                        return;
                    }
                    this.personalData=response.data?.personalData??{}
                    this.sortQuestionnaireStatusList(list);
                    this.checkInStep = 2; // 報到流程步驟
                },
                error: (error) => {
                    console.error('Error fetching questionnaire status:', error);
                    this.toastr.error('查無相關紀錄，請確認或詢問現場人員。', '', { positionClass: 'toast-bottom-center' });
                }
            });

        }
    }

    goToIdLogin() {
        this.router.navigate(['/healthcheck/login']).then();
    }
}